import { Component, input, output } from '@angular/core';
import {
  FaIconComponent,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { FlowpilotChatActionComponent } from '@core/components/sidebar/components/flowpilot/window/content/components/chats/flowpilot-chat-action.component';
import { MenuComponent, MenuTriggerComponent } from '@group24ag/flowkit';
import { NgClass } from '@angular/common';
import { FlowpilotChat } from '@core/components/sidebar/components/flowpilot/window/content/services/flowpilot-chat.service';

@Component({
  selector: 'app-flowpilot-chat-item',
  imports: [
    FaIconComponent,
    FlowpilotChatActionComponent,
    MenuComponent,
    MenuTriggerComponent,
    NgClass,
  ],
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
  template: `
    @let isOpen = trigger.isOpen();
    <div
      #trigger
      flkMenuTrigger
      class="group flex h-[27px] w-full shrink-0 cursor-pointer items-center justify-between gap-x-1 rounded-md px-[7px]"
      [ngClass]="getItemClasses(isOpen)"
      [triggerFor]="menu"
      [disableClick]="true"
      [preferredPosition]="'bottomRight'"
      (opened)="menuOpened.emit()"
      (closed)="menuClosed.emit()"
      (click)="chatClicked.emit()">
      <span
        class="text-dune-700 dark:text-dune-100/90 -mb-[1.5px] max-w-full truncate text-sm text-nowrap">
        {{ chat().name }}
      </span>

      <fa-icon
        class="text-dune-500 dark:text-dune-200 hidden h-5 w-[18px] rounded"
        [ngClass]="getMenuTriggerClasses(isOpen)"
        [icon]="['fas', 'ellipsis-vertical']"
        (click)="trigger.toggleMenu(); $event.stopPropagation()" />

      <ng-template #menu>
        <flk-menu>
          <app-flowpilot-chat-action [pinned]="!!chat().pinned" />
        </flk-menu>
      </ng-template>
    </div>
  `,
})
export class FlowpilotChatItemComponent {
  /** INPUTS **/
  /****/
  readonly chat = input.required<FlowpilotChat>();

  /****/
  readonly selected = input<boolean>(false);

  /** OUTPUTS **/
  /****/
  readonly chatClicked = output<void>();

  /****/
  readonly menuOpened = output<void>();

  /****/
  readonly menuClosed = output<void>();

  constructor(library: FaIconLibrary) {
    library.addIcons(faEllipsisVertical);
  }

  protected getItemClasses(isOpen: boolean) {
    const isSelected = this.selected();
    return {
      'bg-dune-200/35 dark:bg-dune-1000': isSelected,
      'hover:bg-dune-100/65 dark:hover:bg-dune-800/70': !isSelected,
      'bg-dune-100/65 dark:bg-dune-800': isOpen && !isSelected,
    };
  }

  protected getMenuTriggerClasses(isOpen: boolean) {
    const isSelected = this.selected();
    return {
      'flex ': isOpen,
      'group-hover:flex hidden': !isOpen,
      'dark:bg-dune-800 bg-dune-200/60': isOpen && isSelected,
      'dark:bg-dune-700 bg-dune-200/40': isOpen && !isSelected,
      'dark:hover:bg-dune-800 hover:bg-dune-200/60': !isOpen && isSelected,
      'dark:hover:bg-dune-700 hover:bg-dune-200/40': !isOpen && !isSelected,
    };
  }
}
